import React from 'react';

export const MORNING_DIGEST_EVENT = 'workloop:open-morning-digest';

export const openMorningDigest = (event) => {
  event?.preventDefault?.();
  event?.stopPropagation?.();
  window.dispatchEvent(new CustomEvent(MORNING_DIGEST_EVENT));
};

const MorningDigestOpenButton = ({ className = '' }) => (
  <button
    type="button"
    onClick={openMorningDigest}
    onMouseDown={(event) => event.stopPropagation()}
    className={`flex-shrink-0 inline-flex h-7 w-7 items-center justify-center rounded-lg text-amber-600 hover:bg-amber-50 hover:text-amber-700 dark:text-amber-300 dark:hover:bg-amber-900/30 ${className}`}
    title="Today's briefing"
    aria-label="Open today's briefing"
  >
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  </button>
);

export default MorningDigestOpenButton;
